require('./bootstrap');
require('jquery.easing');
require('./components/theme');
import * as Vue from 'vue';
import randomEducationalMessage from './components/RandomEducationalMessage';
import formReservation from './vues/formReservation';
window.formReservation = formReservation;

import formResterInformer from './vues/formResterInformer';
window.formResterInformer = formResterInformer;

let is_touch_device = function () {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}

document.body.classList.add(is_touch_device() ? 'touch-device' : 'no-touch');
document.body.dataset.toucheDevice = is_touch_device() ? 'yes' : 'no';

$(() => {
    let obsoleteBrowsers = (navigator.userAgent.toLowerCase().indexOf('trident') > 0 || navigator.userAgent.toLowerCase().indexOf('msie') > 0),
        msgObsoleteBrowser = document.getElementById('browser-obsolete');
    if (obsoleteBrowsers && msgObsoleteBrowser) {
        msgObsoleteBrowser.classList.remove('d-none');
        let thingsToHide = document.getElementsByClassName('hide-browser-obsolete');
        for (let i = thingsToHide.length - 1; i >= 0; i--) {
            thingsToHide[i].classList.add('d-none');
        }
    }

    randomEducationalMessage();

    (navigator.userAgent.indexOf('Trident') > 0 || navigator.userAgent.indexOf('Edge') > 0 || navigator.userAgent.indexOf('MSIE') > 0) ? document.documentElement.className = 'IE' : '';
    navigator.userAgent.match(/Tablet|iPad/i) || (navigator.userAgent.match(/Android.+Chrome\/[.0-9]*\s?(?!Mobile)/i)) ? document.body.className += ' tablet' : '';

    /** Loader principal */
    let loader = document.getElementById('loader-general');
    loader.style.display = 'none';
    Vue.component('form-reservation', formReservation);
    Vue.component('form-rester-informer', formResterInformer);

    let ctas = document.querySelectorAll('.sticky-elmt a');
    if (!is_touch_device()) {
        for (let i = ctas.length - 1; i >= 0; i--) {
            let listClasses = ctas[i].className;
            ctas[i].className = 'expandLink ' + listClasses;
        }
        setTimeout(function () {
            for (let i = ctas.length - 1; i >= 0; i--) {
                ctas[i].classList.remove('expandLink');
            }
        }, 2000);
    }
});
